import React, { useState, useEffect } from 'react';
import { Drawer, Select, Button, Input, Space, Tag, Form, Spin, Card, message } from 'antd';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL } from '../Components/Constant';
import { ConsoleSqlOutlined, DeleteOutlined } from '@ant-design/icons';


const { Option } = Select;

const CreateRecordFlowDrawer = ({ visible, onClose, nodeData, onSave,selectedNode,setNodeData,isEditingMode }) => {
  const [objects, setObjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [selectedFields, setSelectedFields] = useState([]);
  const [fieldValues, setFieldValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    const fetchObjects = async () => {
      try {
        setLoading(true);
        const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
        const response = await apiService.makeCall();
        setObjects(response);
      } catch (error) {
        console.error('Error fetching objects:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchObjects();
  }, []);
  
   // Populate data for edit mode when nodeData changes
   useEffect(() => {

    if (nodeData && Object.keys(nodeData).length > 0) {
      setName(nodeData.name || '');
      setApiName(nodeData.apiname || '');
      setDescription(nodeData.description || '');
      setSelectedObject(nodeData.parameters?.model || null);
      setSelectedFields(Object.keys(nodeData.parameters?.fields || {}));
      setFieldValues(nodeData.parameters?.fields || {});
      // Fetch fields for the selected object if available
      if (nodeData.parameters?.model) {
        fetchFields(nodeData.parameters.model);
      }
    }
    // else if(nodeData && Object.keys(nodeData).length > 0){
    //   setName(nodeData.name || '');
    //   setApiName(nodeData.apiName || '');
    //   setDescription(nodeData.description || '');
      
    //   // Convert array of fields into an object like parameters.fields
    //   const formattedFields = (nodeData.fields || []).reduce((acc, field) => {
    //     acc[field.field] = field.value;
    //     return acc;
    //   }, {});
    //   setFieldValues(formattedFields || []);
    //   console.log(formattedFields);
    //   setSelectedFields(Object.keys(formattedFields) || []);
    //   setSelectedObject(nodeData.selectedObject || null);
    //   if(nodeData.selectedObject){
    //     fetchFields(nodeData.selectedObject);
    //   }
    // }
    else{
      setName('');
      setApiName('');
      setDescription('');
      setSelectedObject(null);
      setSelectedFields({});
      setFieldValues({});
  
    }
  }, [nodeData]);
  

  const fetchFields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setFields(response);
    } catch (error) {
      console.error('Error fetching fields:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleObjectChange = (value) => {
    setSelectedObject(value);
    setSelectedFields([]); // Reset selected fields when object changes
    setFieldValues({}); // Reset field values
    fetchFields(value); // Fetch new fields for selected object
  };

  const handleFieldSelect = (field) => {
    // Add field to selected fields only if not already selected
    if (!selectedFields.includes(field)) {
      setSelectedFields([...selectedFields, field]);
      setFieldValues({ ...fieldValues, [field]: '' });
    }
  };

  const handleFieldValueChange = (field, value) => {
    setFieldValues({ ...fieldValues, [field]: value });
  };

  const removeField = (field) => {
    const newFields = selectedFields.filter(f => f !== field);
    setSelectedFields(newFields);
    const { [field]: removedField, ...newFieldValues } = fieldValues;
    setFieldValues(newFieldValues);
  };

  const handleSave = () => {
    if (!name || !apiName || !selectedObject || selectedFields.length === 0) {
      message.error('Please fill all required fields and add at least one field to update.');
      return;
    }
    const type = 'Create Records';
    const id =selectedNode.id;
    const data = {
      name,
      type,
      id,
      apiName,
      description,
      selectedObject,
      fields: selectedFields.map(field => ({
        field: field,
        value: fieldValues[field],
      })),
    };
    
    onSave(selectedNode.id,data); // Pass the data to the parent component
    message.success('Record saved successfully!');
    setNodeData([]);
    onClose();
  };

  const handleCancel = () => {
    // Reset all fields when canceling
    setSelectedObject(null);
    setSelectedFields([]);
    setFieldValues({});
    setFields([]);
    setName('');
    setApiName('');
    setDescription('');
    setNodeData([]);
    onClose(); // Close the drawer
  };

  return (
    <Drawer
    title={` Create Records`}
    placement="right"
      width="40%"
      zIndex={1002}   // higher than sidebar
      onClose={handleCancel} // Use handleCancel for closing
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
          <Button onClick={handleCancel} disabled={loading}>Cancel</Button>
          <Button type="primary" onClick={handleSave} disabled={loading}>Save</Button>
        </div>
      }
    >
      <Spin spinning={loading} tip="Loading...">
        <Card style={{ margin: '20px', padding: '20px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
          <Form layout="vertical">
            {/* <Form.Item label="Node ID">{nodeData?.id}</Form.Item>
            <Form.Item label="Node Label">{nodeData?.data?.label}</Form.Item> */}

            {/* Name Input */}
            <Form.Item label="Name" required>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter a name"
                onBlur={() => {
                  if (name) {
                    setApiName(
                      name
                        .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
                        .replace(/\s+/g, "") // Remove spaces
                        .trim()
                    );
                  }
                }}            
              />
            </Form.Item>

            {/* API Name Input */}
            <Form.Item label="API Name" required>
              <Input
                value={apiName}
                onChange={(e) => setApiName(e.target.value)}
                placeholder="Enter API name"
              />
            </Form.Item>

            {/* Description Input */}
            <Form.Item label="Description">
              <Input.TextArea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description"
                rows={3}
              />
            </Form.Item>

            <Form.Item label="Select Object" required>
              <Select onChange={handleObjectChange} placeholder="Select Object" value={selectedObject}>
                {objects.map(obj => <Option key={obj._id} value={obj.name}>{obj.label}</Option>)}
              </Select>
            </Form.Item>

            {/* Fields selection */}
            {selectedObject && (
              <Form.Item label="Select Fields">
                <Select
                  mode="multiple"
                  onSelect={handleFieldSelect}
                  placeholder="Select Fields"
                  value={selectedFields} // No pre-selected fields
                >
                  {fields
                    .filter(field => !selectedFields.includes(field.name)) // Ensure only unselected fields show up
                    .map(field => (
                      <Option key={field._id} value={field.name}>{field.label}</Option>
                    ))}
                </Select>
              </Form.Item>
            )}

            {/* Render selected fields and inputs */}
            {selectedFields.length > 0 && (
              <div>
                <strong>Selected Fields:</strong>
                {selectedFields.map((field) => (
                  <div key={field} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <Tag>{field}</Tag>
                    <Input
                      style={{ marginLeft: '10px', flex: 1 }}
                      value={fieldValues[field]}
                      onChange={(e) => handleFieldValueChange(field, e.target.value)}
                    />
                    <Button
                      danger
                      style={{ marginLeft: '10px' }}
                      onClick={() => removeField(field)}
                      icon={<DeleteOutlined />}
                      >
                      {/* Remove */}
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </Form>
        </Card>
      </Spin>
    </Drawer>
  );
};

export default CreateRecordFlowDrawer;
